import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function MagicLink() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [status, setStatus] = useState("verifying");
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setError("Missing magic-link token.");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/magic-link/verify", { token });
        setUser(data);
        toast.success("Signed in via magic link");
        navigate("/dashboard", { replace: true });
      } catch (err) {
        setStatus("error");
        setError(formatApiError(err, "This magic link is no longer valid."));
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      {status === "verifying" ? (
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-6 w-6 animate-spin text-blue-600" />
          <p className="text-sm text-slate-600">Signing you in…</p>
        </div>
      ) : (
        <div className="max-w-sm text-center">
          <h2 className="font-display text-xl font-semibold text-slate-900">Link not valid</h2>
          <p className="mt-2 text-sm text-slate-600">{error}</p>
          <button onClick={() => navigate("/login")} className="mt-5 text-sm text-blue-600 hover:text-blue-700 font-medium">
            Back to sign in
          </button>
        </div>
      )}
    </div>
  );
}
